import { atom } from 'jotai';

/**
 * True while the education modal was opened by the enable flow, meaning the
 * "Session merge enabled" toast should fire once the modal closes. The
 * modal resets it on close. The toast's own "Learn more" action re-opens the
 * modal without setting it, so closing that re-opened modal never shows a
 * second toast (no toast ↔ modal loop).
 */
export const showEnabledToastOnEducationCloseAtom = atom(false);
